// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Input, type InputProps } from 'antd';
import { Search } from 'lucide-react';
import './SearchInput.less';

type SearchInputProps = Omit<
  InputProps,
  'aria-label' | 'className' | 'prefix' | 'type' | 'variant'
> & { placeholder: string };

const SearchInput = ({ placeholder, ...props }: SearchInputProps) => (
  <Input
    {...props}
    type="search"
    variant="borderless"
    className="search-input"
    placeholder={placeholder}
    aria-label={placeholder}
    prefix={<Search size={24} />}
  />
);

export default SearchInput;
